/* import __COLOCATED_TEMPLATE__ from './standalone-copilot-dropdown-item.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import templateOnlyComponent from '@ember/component/template-only';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

interface Signature {
  Args: {
    componentAttrs: {
      description: string;
      copilotSeatPrice?: string;
      icon: InterfaceIconName;
    };
  };
}

const StandaloneCopilotDropdownItem = templateOnlyComponent<Signature>();
export default StandaloneCopilotDropdownItem;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Teammates::Scim::StandaloneCopilotDropdownItem': typeof StandaloneCopilotDropdownItem;
    'new-settings/workspace/teammates/scim/standalone-copilot-dropdown-item': typeof StandaloneCopilotDropdownItem;
  }
}
